import Stylus from './Stylus';
import ConnectorDrawingBrush from './ConnectorDrawingBrush';
import ConnectorMenu from '../toolbars/ConnectorMenu';
import type Connector from '../objects/Connector';
import lineSVG from '../assets/icons/line.svg';
import lineWithArrowSVG from '../assets/icons/lineWithArrow.svg';
import lineWithDoubleArrowSVG from '../assets/icons/lineWithDoubleArrow.svg';
import lineOrthogonalSVG from '../assets/icons/lineOrthogonal.svg';
import lineBezierSVG from '../assets/icons/lineBezier.svg';
import { svgToIcon } from '../utils/svg';
import type WhiteboardController from '../controllers/WhiteboardController';
import { CONNECTOR_END_STYLE } from '../constants';
import { ConnectorRouting } from '../objects/ConnectorRouting';

export type StylusConnectorOptions = Partial<
  Pick<Connector, 'lineRouting' | 'endStyles' | 'strokeType' | 'stroke'>
> & {
  iconName?: string;
};

// Create new line/connector objects.
class StylusConnector extends Stylus {
  public options: StylusConnectorOptions;

  constructor({
    controller,
    options = {},
  }: {
    controller: WhiteboardController;
    options?: StylusConnectorOptions;
  }) {
    super({ controller });
    this.options = options;
  }

  activate() {
    const brush = new ConnectorDrawingBrush(
      this.controller.canvas,
      this.options,
      undefined,
      undefined,
      () => this.drawingComplete()
    );
    this.controller.canvas.isDrawingMode = true;
    this.controller.canvas.freeDrawingBrush = brush;
  }

  iconFile() {
    switch (this.options.lineRouting) {
      case ConnectorRouting.ROUTING_STRAIGHT:
        if (
          this.options.endStyles &&
          this.options.endStyles[0] === CONNECTOR_END_STYLE.NONE &&
          this.options.endStyles[1] === CONNECTOR_END_STYLE.NONE
        ) {
          return lineSVG;
        } else if (
          this.options.endStyles &&
          this.options.endStyles[0] === CONNECTOR_END_STYLE.NONE &&
          this.options.endStyles[1] === CONNECTOR_END_STYLE.FILLED_ARROW
        ) {
          return lineWithArrowSVG;
        } else {
          return lineWithDoubleArrowSVG;
        }
      case ConnectorRouting.ROUTING_ORTHOGONAL_AUTO:
        return lineOrthogonalSVG;
      case ConnectorRouting.ROUTING_BEZIER:
        return lineBezierSVG;
      default:
        return lineWithArrowSVG;
    }
  }

  description() {
    return 'Connector';
  }

  renderIcon() {
    return svgToIcon(this.iconFile());
  }

  cursor() {
    return 'crosshair';
  }

  subMenu() {
    return ConnectorMenu;
  }

  subMenuName() {
    return 'connectors';
  }
}

export default StylusConnector;
